import { useNavigate } from "react-router-dom";

export default function Page404() {
  const navigate = useNavigate();
  return (
    <div className="flex h-screen items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center justify-center bg-white p-10 rounded-lg shadow-lg">
        <img src="/graziani.png" alt="Graziani" className="w-1/2 mb-10" />
        <h1 className="text-4xl font-bold">404</h1>
        <p className="text-lg text-gray-600">Pagina non trovata</p>

        <button
          className="btn btn-outline btn-neutral w-1/2 mt-10"
          onClick={() => navigate(-1)}
        >
          Torna indietro
        </button>
      </div>
    </div>
  );
}
